import styled from '@emotion/styled';
import { theme } from '../../styles';

import { Marker } from 'react-simple-maps';

export const MarkerStyled = styled(Marker)`
  opacity: ${(props) => (props.aMarkerIsHovered ? 0.2 : 1)};
  transition: opacity 400ms ease;
`;

export const MapFiltersContainer = styled.div`
  color: ${theme.colors.primaryred};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: -30px;

  @media (min-width: ${theme.breakpoints.md}) {
    margin-top: -140px;
    align-items: center;
    flex-direction: row;
    justify-content: flex-end;
  }

  .MuiInput-underline {
    &::before {
      display: none;
    }
  }

  /* Mobile layout for filter mode */
  @media (max-width: ${theme.breakpoints.md}) {
    &.filter-mode {
      flex-direction: column;
      align-items: stretch;
      width: 100%;
    }
  }
`;

export const MapFiltersHeader = styled.div`
  font-weight: 600;
  letter-spacing: 0.04em;
  border-bottom: 2px solid white;
  display: block;
  padding: 10px;
  width: 100%;

  @media (min-width: ${theme.breakpoints.md}) {
    margin-right: 30px;
    width: auto;
    border-bottom: 0;
  }
`;

export const MapFiltersBody = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
`;

export const FilterToggleButton = styled.button`
  background: transparent;
  border: 1.5px solid ${theme.colors.primaryred};
  color: ${theme.colors.primaryred};
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 12px;
  margin: 7px 0;
  transition: all 0.2s ease;

  &:hover {
    background: ${theme.colors.primaryred};
    color: white;
  }

  &:focus {
    outline: none;
  }

  @media (min-width: ${theme.breakpoints.md}) {
    font-size: 14px;
    line-height: 1;
    padding: 10px 20px;
  }
`;

export const ClearFiltersButton = styled.button`
  background: transparent;
  border: 1.5px solid ${theme.colors.primaryred};
  color: ${theme.colors.primaryred};
  font-weight: 600;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  transition: all 0.2s ease;
  margin-left: 10px;
  flex-shrink: 0;

  &:hover {
    background: ${theme.colors.primaryred};
    color: white;
  }
`;
